import { render, staticRenderFns } from "./productTweets.vue?vue&type=template&id=49e1f79c&"
import script from "./productTweets.vue?vue&type=script&lang=js&"
export * from "./productTweets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports